import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Tabs, Tab } from 'react-tab-view';
import { FaSpeakerDeck } from 'react-icons/fa';
import '../styles/tabbedviewStyles.css';

// 👇 tab screens
import Events from './Events';
import Announcements from './Announcements';
import JobOpportunities from './JobOpportunities';

export default function TabbedView({
    events,
    fetchEvents,
    announcements,
    jobPostings,
    alumniData,
}) {
    const tabRef = useRef();

    useEffect(() => {
        // console.log('\ntabRef:', tabRef.current?.refs);
    }, []);

    // 👇 handler for onChange
    const handChange = (e) => {
        // console.log('\n\nonChange:', e);
    };

    const eventsHeading = (
        <div>
            <FaSpeakerDeck />
            <h1>Events</h1>
        </div>
    );

    const headers = ['Events', 'Announcements', 'Job Opportunities'];

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <Tabs headers={headers}>
                <Tab>
                    <Events events={events} alumniData={alumniData} fetchEvents={fetchEvents} />
                </Tab>
                <Tab>
                    <Announcements announcements={announcements} />
                </Tab>
                <Tab>
                    <JobOpportunities jobPostings={jobPostings} />
                </Tab>
            </Tabs>
        </div>
    );
}
